<section [class.dialog-style]="isInDialog()" class="achievements space__box">
  <div class="achievements__badges">
    @if (showText()) {
      <h4>{{ 'achievements.headline' | translate }}</h4>
    }

    <div class="achievements__badges--icons">
      @for (achievement of allAchievements; track achievement.level) {
        <img
                [alt]="achievement"
                [src]="achievement.level | achievementIcon : currentLevel(): isInDialog() : allCompletedLevels()"
                [title]="(userAchievements()[achievement.key] ? ('achievements.badges_earned' | translate) : ('achievements.badges_locked' | translate)) + ' ' + achievement.label"
        />
      }
    </div>
  </div>
</section>
